<button mat-icon-button class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<div class="dialog-content-wrapper shippingAddressDialog" id="shippingAddressDialog-wrapper">
  <mat-toolbar class="header m-0 fx-row">
    <mat-toolbar-row class="fx-row fx-main-between fx-cross-center fx-flex">
      <span class="title dialog-title fx-flex" translate=""> Edit Shipping Address</span>
    </mat-toolbar-row>
  </mat-toolbar>
  <div mat-dialog-content id="shippingAddressDialog-content" class="fx-col">
    <div class="">
      <mat-checkbox [checked]="!newAddressSelected" (change)="onClickDifferentAddress(false)">Use default address</mat-checkbox>
    </div>
    <div class="m-b-30 m-t-10 p-15 borderBox cursor-pointer fx-col">
      <div class="fx-row fx-flex-100-in-col">
        <div class="fx-flex-10">
          <mat-icon>person</mat-icon>
        </div>
        <div class="fx-flex-90">
          <span [textContent]="userService.customerData.FirstName+' '+userService.customerData.LastName"></span>
        </div>
      </div>
      <div class="fx-row fx-flex-100-in-col">
        <div class="fx-flex-10">
          <mat-icon> location_on</mat-icon>
        </div>
        <div class="fx-flex-90">
          <span [textContent]="defaultAddress.Street1"></span>
          <span [textContent]="defaultAddress.Street2"></span>
          <span [textContent]="defaultAddress.City"></span>,
          <span [textContent]="defaultAddress.Region"></span>
          <span [textContent]="defaultAddress.PostalCode"></span>
          <span [textContent]="defaultAddress.CountryCode"></span>
        </div>
      </div>
    </div>
    <div>
      @if (differentAddressShow === false) {
        <div>
          <span class="cursor-pointer c-1" (click)="onClickDifferentAddress(true)" translate="different_address"></span>
        </div>
      }
      @if (differentAddressShow === true) {
        <div class="fx-col">
          <div>
            <mat-checkbox [checked]="newAddressSelected" [attr.disabled]="newAddressSelected" [disableRipple]="true"
            (click)="$event.preventDefault()">{{'use_new_address' | translate}}</mat-checkbox>
          </div>
          <div>
            <form>
              <div class="fx-col">
                <div class="fx-row fx-flex-100-in-col">
                  <mat-form-field class="ds-validate fx-flex">
                    <mat-label translate="first_name"></mat-label>
                    <input name="firstName"  [(ngModel)]="newShipping.FirstName"
                      [ngModelOptions]="{standalone: true}"  validate noempty="true" matInput>
                  </mat-form-field>
                </div>
                <div class="fx-row fx-flex-100-in-col">
                  <mat-form-field class="ds-validate fx-flex" >
                    <mat-label translate="last_name"></mat-label>
                    <input name="lastName"  [(ngModel)]="newShipping.LastName"
                      [ngModelOptions]="{standalone: true}"  validate noempty="true" matInput>
                  </mat-form-field>
                </div>
                <div class="fx-row fx-flex-100-in-col">
                  <mat-form-field class="ds-validate fx-flex" >
                    <mat-label translate="Country"></mat-label>
                    <mat-select  [ngModelOptions]="{standalone: true}"  [(ngModel)]="newShipping.CountryCode" (selectionChange)="getCountryState(newShipping.CountryCode)" validate noempty="true">
                      @for (country of allowedCountries; track country) {
                        <mat-option
                          [value]="country.CountryCode">
                          <img [src]="'https://directscalestring.directscale.com/flags/4x3/'+country.CountryCode+'.svg'"
                            width="18"> {{country.CountryName}}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="fx-row fx-flex-100-in-col">
                    <mat-form-field class="ds-validate fx-flex" >
                      <mat-label translate="state"></mat-label>
                      <mat-select [(ngModel)]="newShipping.Region"
                        [ngModelOptions]="{standalone: true}" validate noempty="true">
                      @for (state of states; track state) {
                        <mat-option [value]="state.StateCode">
                          {{state.StateName}}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="fx-row fx-flex-100-in-col">
                  <mat-form-field class="ds-validate fx-flex" >
                    <mat-label translate="city"></mat-label>
                    <input name="city"  [(ngModel)]="newShipping.City"
                      [ngModelOptions]="{standalone: true}"  validate noempty="true" matInput>
                  </mat-form-field>
                </div>
                <div class="fx-row fx-flex-100-in-col" >
                  <mat-form-field class="ds-validate fx-flex" >
                    <mat-label translate="zip"></mat-label>
                    <input name="zip"  [(ngModel)]="newShipping.PostalCode"
                      [ngModelOptions]="{standalone: true}"  validate noempty="true" matInput>
                  </mat-form-field>
                </div>
                <div class="fx-row fx-flex-100-in-col">
                  <mat-form-field class="ds-validate fx-flex" >
                    <mat-label translate="street_address" ></mat-label>
                    <input name="streetAddress"  [(ngModel)]="newShipping.Street1"
                      [ngModelOptions]="{standalone: true}"  validate noempty="true" matInput>
                    </mat-form-field>
                  </div>
                  <div class="fx-row fx-flex-100-in-col">
                    <mat-form-field class="ds-validate fx-flex" >
                      <mat-label translate="street_address2"></mat-label>
                      <input name="streetAddress2"  [(ngModel)]="newShipping.Street2"
                        [ngModelOptions]="{standalone: true}"  validate noempty="true" matInput>
                      </mat-form-field>
                    </div>
                    <div class="fx-row fx-flex-100-in-col">
                      <mat-form-field class="ds-validate fx-flex" >
                        <mat-label translate="phone_number_"></mat-label>
                        <input name="phoneNumber"  [(ngModel)]="newShipping.Phone"
                          [ngModelOptions]="{standalone: true}"  validate noempty="true" matInput>
                      </mat-form-field>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          }
        </div>
      </div>
      <div mat-dialog-actions class="m-0 p-16 fx-row fx-main-end fx-cross-center">
        <div>
          <!-- Close modal, staying with default address -->
          @if (!newAddressSelected) {
            <button mat-raised-button color="primary" id="updateaddress" class="text-uppercase" (click)="close()">{{'update_' | translate}}</button>
          }
          <!-- Update address and close -->
          @if (newAddressSelected) {
            <button mat-raised-button color="primary" id="update-new-address" class="text-uppercase" validate trigger-check="true"  (success)="saveNewAddress()"
            >{{'next_' | translate}}</button>
          }
        </div>
      </div>
    </div>
